export default __webpack_public_path__ + "static/media/zendesk.6f3c91e3.svg";